module.exports = __webpack_public_path__ + "fonts/LatoLatin-SemiboldItalic.20c6baa.woff";